import { AttackPattern, PatternState } from '../AttackPattern.js';

/**
 * Skyfall — unlike every other shared pattern, these bullets don't
 * originate from the boss at all: it samples a handful of the player's
 * positions during the telegraph, then bursts a small ring of bullets
 * outward from each marked spot once active. Punishes staying in one place
 * during the telegraph rather than reading the boss's own position.
 */
export class Skyfall extends AttackPattern {
  constructor({ minPhase = 0, config }) {
    super({ name: 'Skyfall', telegraphDuration: 0.9, activeDuration: 0.3, minPhase });
    this.config = config; // { markerCount, ringCount, damage, speed }
  }

  onBegin(_boss, player) {
    this._markers = [];
    this._sampleTimer = 0;
    this._recordMarker(player);
  }

  onTelegraphTick(dt, _boss, player) {
    this._sampleTimer -= dt;
    if (this._sampleTimer <= 0 && this._markers.length < this.config.markerCount) {
      this._recordMarker(player);
      this._sampleTimer = this.telegraphDuration / this.config.markerCount;
    }
  }

  _recordMarker(player) {
    this._markers.push({ x: player.x, y: player.y });
  }

  onActiveStart(_boss, _player, pool) {
    const { ringCount, damage, speed } = this.config;
    for (const marker of this._markers) {
      for (let i = 0; i < ringCount; i++) {
        const angle = (i / ringCount) * Math.PI * 2;
        pool.fire({
          x: marker.x,
          y: marker.y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          radius: 2.5,
          damage,
          color: '#ffd166',
          lifetime: 2,
        });
      }
    }
  }

  // Reuses the 'echoTelegraph' visual kind (Game.js's _drawAttackVisuals) —
  // dashed rings at each marked spot, same idea as Riven Choir's Echo Chorus
  // preview, just marking player-history positions instead of boss echoes.
  getVisual(_boss) {
    if (this.state !== PatternState.TELEGRAPH || !this._markers?.length) return null;
    return { kind: 'echoTelegraph', echoes: this._markers };
  }
}
